var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscovIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0669,
    cy: 35.0669,
    r: 35.0669,
    fill: "#EFE5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1191 21.543V23.7718C40.1191 25.8728 40.1191 26.9234 40.7729 27.5757C41.4237 28.2294 42.4743 28.2294 44.5768 28.2294H46.8056",
    stroke: "#724189",
    strokeWidth: 1.78306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7189 34.1776H41.606M29.7189 38.6353H41.606M29.7189 43.0929H35.9151M23.7754 41.6071V29.72C23.7754 25.5179 23.7754 23.4154 25.0815 22.1108C26.3861 20.8047 28.4886 20.8047 32.6907 20.8047H38.8898C39.496 20.8047 39.8006 20.8047 40.074 20.9176C40.346 21.0305 40.5614 21.2445 40.9908 21.6754L46.6788 27.3634C47.1097 27.7943 47.3237 28.0083 47.4366 28.2817C47.5495 28.5536 47.5495 28.8582 47.5495 29.4644V41.6071C47.5495 45.8091 47.5495 47.9117 46.2434 49.2163C44.9388 50.5224 42.8363 50.5224 38.6342 50.5224H32.6907C28.4886 50.5224 26.3861 50.5224 25.0815 49.2163C23.7754 47.9117 23.7754 45.8091 23.7754 41.6071Z",
    stroke: "#724189",
    strokeWidth: 1.78306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovIc);
export default __webpack_public_path__ + "static/media/discov-ic.ac8fc96e6e6ccba14af4f70b1c3dc969.svg";
export { ForwardRef as ReactComponent };